import React, { Suspense } from 'react';
import LoadingScreen from '~/components/screens/LoadingScreen';

const SettingsScreenComponent = React.lazy(
    () => import(/* webpackChunkName: "settings" */ '~/modules/settings/screens/SettingsScreen')
);

type Props = {
    setActiveRightTab?: Function;
};

export default function SettingsScreen({ setActiveRightTab }: Props) {
    return (
        <Suspense fallback={<LoadingScreen />}>
            <SettingsScreenComponent setActiveRightTab={setActiveRightTab} />
        </Suspense>
    );
}
